import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import Pagination from '@/components/Pagination.vue'
import { getGardListApi } from '@/apis/merchant'
import SelectBrand from '@/components/SelectBrand.vue'
import { BrandCat } from '@/enums/brand'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'


export default /*@__PURE__*/_defineComponent({
  __name: 'RatingList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()
const userType = store.state.user.userInfo.user_type

const filters = reactive({
    brand_id: '',
    cat_id:'',
    order_date:'',      //月份
    level:'',       //  级别
    page: 1,      // 当前页码
    page_size: 10,     // 每页显示条数
})
const dateList = ref([])
const tableData = ref([])
const total = ref(0)
const getList = () => {
        getGardListApi(filters).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
}
const getDateList = () => {
    proxy.$http.get(`/admin/invoice/getDateList`).then(res => {
        if(res.code == 0){
            dateList.value = res.data;
        }else{
            dateList.value = [];
        }
    })
}
const onExport = (type) => {
    window.open(`${Keys.baseUrl}/ptapi/Brand/get_shop_gradelist?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&is_export=${type}`)
}
// 跳转至客诉详情页面
const toEdit = (row, t) => {
    // router.push(`/merchant/customer-complaint?id=${row.id}&t=${t}`)
    router.push(`/merchant-admin/rating-appeal?id=${row.id}&t=${t}`)
}
const onBrandChange = (val) => {
    filters.brand_id = val
}

const search = () => {
    filters.page = 1
    getList()
}

const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onMounted(() => {
    getList() 
    getDateList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, {
        class: "filter-item",
        ifBody: 2,
        onBrandChange: onBrandChange
      }),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.cat_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.cat_id) = $event)),
        placeholder: "请选择分类",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "蛋糕",
            value: _unref(BrandCat)['蛋糕']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "零食",
            value: _unref(BrandCat)['零食']
          }, null, 8, ["value"]),
          _createVNode(_component_el_option, {
            label: "鲜花",
            value: _unref(BrandCat)['鲜花']
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        style: {"width":"150px"},
        modelValue: filters.order_date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.order_date) = $event)),
        placeholder: "时间（月份）",
        clearable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.value,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(userType) == 1)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: filters.level,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.level) = $event)),
            placeholder: "请选择级别",
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "A级",
                value: "1"
              }),
              _createVNode(_component_el_option, {
                label: "B级",
                value: "2"
              }),
              _createVNode(_component_el_option, {
                label: "C级",
                value: "3"
              }),
              _createVNode(_component_el_option, {
                label: "D级",
                value: "4"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onExport(1)))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cat_type",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "order_date",
          label: "月份"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_amount",
          label: "销售额"
        }),
        _createVNode(_component_el_table_column, {
          prop: "discount",
          label: "折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "discount_score",
          label: "折扣评分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_score",
          label: "销售额评分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "appeal_score",
          label: "客诉评分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cover_score",
          label: "覆盖评分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "multiple_score",
          label: "综合打分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "multiple_score",
          label: "扣分类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_score",
          label: "总分"
        }),
        _createVNode(_component_el_table_column, {
          prop: "level",
          label: "级别"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "210"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toEdit(scope.row, 'edit'))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("查看客诉详情")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})